import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { LayerApi } from '../../../api/layer-api';
import { UserApi } from '../../../api/user-api';
import { InputConverter } from '../../../inputConverter';
import { BaseComponent } from '../../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-unshare-layer',
    styleUrls: ['../../sharedStyles/base.scss', './unshare-layer.component.scss'],
    templateUrl: './unshare-layer.component.html'
})
export class UnshareLayerComponent extends BaseComponent {
    _layerId: number;
    @Input()
    @InputConverter()
    get layerId() { return this._layerId; }
    set layerId(value: number) {
        this._layerId = value;
        if (this._layerId) {
            this.updateData();
        }
    }

    loading: boolean = false;
    unshared: any[] = [];
    unsharedIds: any[] = [];
    shared: { id: number; email: string; firstName: string; lastName: string }[] = [];
    @Output() readonly onclose: EventEmitter<void> = new EventEmitter<void>();
    unsharingLayer = false;
    successMessage = false;
    failureMessage = false;
    layerTitle = '';

    constructor(_vcr: ViewContainerRef, private readonly layerApi: LayerApi, private readonly userApi: UserApi, private readonly cdr: ChangeDetectorRef) {
        super(_vcr, true);
        this.registerEvent('onclose', this.onclose);
    }

    async updateData() {
        this.loading = true;

        const layers = await this.getLayers();
        this.layerTitle = layers[0].name;
        const userIds: number[] = [];
        for (const userLayer of layers[0].userLayers) {
            if (userLayer.accessLevel !== 'OWNER') {
                userIds.push(userLayer.userId);
            }
        }
        this.shared = userIds.length > 0 ? await this.getUsers(userIds) : [];

        this.loading = false;
        this.cdr.detectChanges();
    }

    async getLayers() {
        return this.layerApi.getLayers([this.layerId], 'name, userLayers{accessLevel, userId}');
    }

    async getUsers(userIds: number[]): Promise<{id: number; email: string; firstName: string; lastName: string}[]> {
        return await this.userApi.getUsers(userIds);
    }

    async unshare() {
        return this.layerApi.unshareLayer(this.unsharedIds, this.layerId);
    }

    unshareUser(index: number) {
        this.unshared.push(this.shared[index]);
        this.unsharedIds.push(this.shared[index].id);
        this.shared.splice(index, 1);
    }

    undoUnshare(index: number) {
        this.shared.push(this.unshared[index]);
        this.unshared.splice(index, 1);
        this.unsharedIds.splice(index, 1);
    }

    async unshareLayer() {
        const milliseconds = 3000;
        this.unsharingLayer = true;
        try {
            const result = await this.unshare();
            if (result) {
                this.unsharingLayer = false;
                this.successMessage = true;
                this.resetAndClose();
                setTimeout(() => {
                    this.successMessage = false;
                },         milliseconds);
            } else {
                this.unsharingLayer = false;
                this.failureMessage = true;
                setTimeout(() => {
                    this.failureMessage = false;
                },         milliseconds);
            }
        } catch (error) {
            this.unsharingLayer = false;
            this.failureMessage = true;
            setTimeout(() => {
                this.failureMessage = false;
            },         milliseconds);
        }
    }

    resetAndClose() {
        this.shared = [];
        this.unshared = [];
        this.unsharedIds = [];
        this.onclose.emit();
    }
}
